import { getNativeInfo } from '@docs/common'
import { DEFAULT_APP_NAME } from 'common/constant'
import { initSensors, sensors } from 'common/sensors'
import { kebabCase } from 'lodash'
import qs from 'qs'
import { render } from 'react-dom'
import './i18n'

import App from './App'
// import reportWebVitals from './reportWebVitals';
import { fontFaceStyles, fontVariables } from './fonts'
import './index.scss'

// 注入字体样式
const styleElement = document.createElement('style')
styleElement.innerHTML = fontFaceStyles + fontVariables
document.head.appendChild(styleElement)

initSensors()
render(<App />, document.getElementById('root'))

function init() {
  // const param = qs.parse(window.location.search.substr(1))
  // // 真实的 app 环境
  // if (typeof window?.EufyJS !== 'undefined' || typeof window?.top?.WebViewJavascriptBridge !== 'undefined') {
  //   window.__IS_APP__ = true
  //   getAppName().then(name => {
  //     document.body.classList?.toggle(kebabCase(name))
  //   })
  // } else {
  //   let appName = typeof param.app === 'string' ? param.app : DEFAULT_APP_NAME
  //   document.body.classList?.toggle(kebabCase(appName))
  // }
  // // 模拟的 app 环境, 开发环境使用
  // if (param.__IS_APP__ && process.env.NODE_ENV === 'development') {
  //   window.__IS_APP__ = true
  // }
  const params = qs.parse(window.location.search.substr(1))
  const appName = typeof params.app === 'string' ? params.app : DEFAULT_APP_NAME
  getNativeInfo()
    .then(res => {
      document.body.classList?.toggle(kebabCase(res?.name || appName))
      // start_ai_generated
      if (res && Object.keys(res).length > 0) {
        //代表手机端
        window.__IS_APP__ = true
      }
      // end_ai_generated
      const distinctId = res?.user_id || res?.gtoken
      if (distinctId) {
        sensors.login(distinctId)
      }
    })
    .catch(err => {
      document.body.classList?.toggle(kebabCase(appName))
    })
}

init()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
